import { render } from "./EquipmentTypeTable.vue?vue&type=template&id=2b8216d4&scoped=true"
import script from "./EquipmentTypeTable.vue?vue&type=script&lang=js"
export * from "./EquipmentTypeTable.vue?vue&type=script&lang=js"

import "./EquipmentTypeTable.vue?vue&type=style&index=0&id=2b8216d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8216d4"]])

export default __exports__